import React, { useCallback, useEffect } from "react";
import { CommandStatus, QueryStatus } from "@lookiero/messaging-react";
import { useLogger } from "@lookiero/sty-psp-logging";
import { usePlayGame } from "../../domain/game/react/usePlayGame";
import { useViewGameByCustomerId } from "../../projection/game/react/useViewGameByCustomerId";
import { LookAndLike as LookAndLikeComponent, } from "../components/templates/lookAndLike/LookAndLike";
const LookAndLike = ({ customerId, view, standalone = false, onError, onFetched, onReady, ...props }) => {
    const logger = useLogger();
    const [game, gameStatus] = useViewGameByCustomerId({ customerId });
    const [playGame, playGameStatus] = usePlayGame({ view, logger });
    const handleOnChange = useCallback(playGame, [playGame]);
    useEffect(() => {
        if (gameStatus === QueryStatus.ERROR || playGameStatus === CommandStatus.ERROR) {
            onError?.();
        }
    }, [gameStatus, onError, playGameStatus]);
    useEffect(() => {
        if (game) {
            onFetched?.({ gameProductVariants: game?.gameProductVariants || [], lastGame: game?.lastGame || false });
        }
    }, [game, onFetched]);
    const dependenciesLoadedStatuses = [QueryStatus.ERROR, QueryStatus.SUCCESS];
    const dependenciesLoaded = dependenciesLoadedStatuses.includes(gameStatus);
    useEffect(() => {
        if (!dependenciesLoaded || game?.gameProductVariants.length === 0) {
            return;
        }
        onReady?.();
    }, [dependenciesLoaded, game?.gameProductVariants.length, onReady]);
    if (!dependenciesLoaded || ((game === null || game?.gameProductVariants.length === 0) && !standalone)) {
        return null;
    }
    return (React.createElement(LookAndLikeComponent, { ...props, gameProductVariants: game?.gameProductVariants || [], lastGame: game?.lastGame || false, onChange: handleOnChange }));
};
export { LookAndLike };
